import SEO from "@/components/SEO";
export default function PrivacyCookiesPage() {
  return (
    <div className="min-h-screen bg-white text-black px-6 md:px-20 pt-32 pb-12">
      <SEO
        title="Privacy & Cookies Policy | VANCO"
        description="How VANCO uses cookies and similar technologies on vanco.ai, and how you can manage your preferences."
        path="/privacy-cookies"
      />
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-semibold mb-8">Privacy & Cookies</h1>

        <p className="mb-4 font-light">
          What exactly are cookies? In order to collect the information including personal data as described in this Notice, we may use cookies and similar technology on our website.
          A cookie is a small piece of information which is sent to your browser and stored on your computer&apos;s hard drive, mobile phone or other device. Cookies can be first party,
          i.e. cookies that the website you are visiting places on your device, or third party cookies, i.e. cookies placed on your device through the website but by third parties,
          such as, Google. Cookies are used for the following purposes:
        </p>

        <ul className="list-disc pl-6 mb-6 space-y-2 font-light">
          <li>
            <strong>Necessary cookies</strong> - these cookies are required for you to be able to use some important features on our website, such as logging in. These cookies
            don&apos;t collect any Personal Data.
          </li>
          <li>
            <strong>Functionality cookies</strong> - these cookies provide functionality that makes using our service more convenient and makes providing more personalized
            features possible. For example, they might remember your name and e-mail so you don&apos;t have to re-enter this information next time when commenting.
          </li>
          <li>
            <strong>Analytics cookies</strong> - these cookies are used to track the use and performance of our website and services
          </li>
          <li>
            <strong>Advertising cookies</strong> - these cookies are used to deliver advertisements that are relevant to you and to your interests. In addition, they are used to limit the number
            of times you see an advertisement. They are usually placed to the website by advertising networks with the website operator&apos;s permission. These cookies remember
            that you have visited a website and this information is shared with other organizations such as advertisers. Often targeting or advertising cookies will be linked
            to site functionality provided by the other organization.
          </li>
        </ul>

        <p className="mb-4 font-light">
          Analytics Cookies allow VANCO to monitor and analyze the usage of the Website. Our cookies store randomly assigned user identification numbers, pages visited by a
          visitor, time spent on a page, clicks, demographic information about the visitor such as country, IP address, device and operating system used by the visitor.
          We also use cookies for distinguishing users and user sessions and for identifying new users and sessions, to determine the traffic source that explains how the user
          reached our site and to throttle user request rate in order to limit the number of data requests in a time frame.
        </p>
        <p className="mb-4 font-light">
          Some of the cookies used by us are necessary for the functionality of the website to store the consent of the users for dropping advertising and other cookies.
          We also use advertising cookies of our partners like Facebook, LinkedIn and Twitter for re-targeting and marketing purposes.
        </p>

        <p className="font-light">
          When you arrive on our website a pop-up message will appear asking for your consent to place cookies on your device. In order to provide
          your consent, please go through the details of cookies used by our website for different purposes. You can set your preferences accordingly and click &apos;OK&apos;. Once your
          consent has been provided, this message will not appear again when you revisit. If you, or another user of your device, wish to withdraw your consent at any time, you
          can do so by opting out as per your choice by clicking on the privacy icon on the bottom left corner, which will let you check and edit your consent status with a
          single click.
        </p>
      </div>
    </div>
  );
}
